import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ProfileIcon = ({ sx, ...props }: SvgIconProps) => {
  return props.type !== 'bg' ? (
    <SvgIcon viewBox="0 0 18 18" sx={{ height: '18px', width: '18px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M15 15.75C15 14.7033 15 14.18 14.8708 13.7541C14.58 12.7953 13.8297 12.045 12.8709 11.7542C12.445 11.625 11.9217 11.625 10.875 11.625H7.125C6.07833 11.625 5.55499 11.625 5.12914 11.7542C4.17034 12.045 3.42003 12.7953 3.12918 13.7541C3 14.18 3 14.7033 3 15.75M12.375 5.625C12.375 7.48896 10.864 9 9 9C7.13604 9 5.625 7.48896 5.625 5.625C5.625 3.76104 7.13604 2.25 9 2.25C10.864 2.25 12.375 3.76104 12.375 5.625Z"
        stroke="#14191F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ) : (
    <SvgIcon viewBox="0 0 44 45" sx={{ width: '44', height: '45', fill: 'transparent', ...sx }} {...props}>
      <rect y="0.5" width="44" height="44" fill="url(#pattern0)" />
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use transform="scale(0.00195312)" />
        </pattern>
        <image id="image0_2036_7001" width="512" height="512" />
      </defs>
    </SvgIcon>
  );
};

export default ProfileIcon;
